// assets/cart-upsell.js
(function () {
  // Anti-flicker / anti-race
  let latestRefreshRunId = 0;
  let upsellRefreshTimeout = null;

  const UPSell = {
    globalContainerSelector: "[data-upsell-container]",
    slotSelector: "[data-upsell-slot]",

    async refresh() {
      const container = document.querySelector(this.globalContainerSelector);
      if (!container) return;

      // identifiant de ce "run" pour éviter qu'un ancien refresh écrase le plus récent
      const runId = ++latestRefreshRunId;

      try {
        const cart = await fetch("/cart.js").then((r) => r.json());

        // si entre-temps un autre refresh plus récent a démarré, on abandonne
        if (runId !== latestRefreshRunId) return;

        // 🧠 Quantités par ID de variante ET par ID de produit
        const quantitiesByVariantId = {};
        const quantitiesByProductId = {};

        cart.items.forEach((item) => {
          const vKey = String(item.id);         // variant_id
          const pKey = String(item.product_id); // product_id

          quantitiesByVariantId[vKey] =
            (quantitiesByVariantId[vKey] || 0) + item.quantity;

          quantitiesByProductId[pKey] =
            (quantitiesByProductId[pKey] || 0) + item.quantity;
        });

        const variantIdsInCart = Object.keys(quantitiesByVariantId);
        const productIdsInCart = Object.keys(quantitiesByProductId);

        // 🧹 1) Nettoyage des enfants orphelins (_upsell_parent_variant_id sans parent)
        const orphanLineKeys = [];
        cart.items.forEach((item) => {
          const props = item.properties || {};
          const parentId = props._upsell_parent_variant_id;
          if (!parentId) return;

          const key = String(parentId);
          const parentExists =
            variantIdsInCart.includes(key) || productIdsInCart.includes(key);

          if (!parentExists) {
            // cet enfant n'a plus son parent dans le panier → on le supprime
            if (item.key) {
              orphanLineKeys.push(item.key);
            }
          }
        });

        if (orphanLineKeys.length) {
          await Promise.all(
            orphanLineKeys.map((lineKey) =>
              fetch("/cart/change.js", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Accept: "application/json",
                },
                body: JSON.stringify({
                  id: lineKey,
                  quantity: 0,
                }),
              })
            )
          );
          // On arrête ce refresh, le cart va être rerendu et un nouveau refresh sera lancé proprement
          return;
        }

const rawRules = Array.isArray(window.MOODZ_UPSELL_RULES)
  ? window.MOODZ_UPSELL_RULES
  : [];

// 🔎 Normalisation
const normalizedRules = rawRules.map((rule) => {
  const triggerRaw = String(rule.triggerVariantId || "").trim();

  const triggerIds = triggerRaw
    .split(",")
    .map((s) => s.trim())
    .filter((s) => s !== "");

  // 🔁 multi-exclude : "123,456"
  const excludeRaw = String(rule.excludeVariantId || "").trim();
  const excludeIds = excludeRaw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);

  return {
    // logique
    id: String(rule.id || ""),
    upsellHandle: String(rule.upsellHandle || "").trim(),
    triggerIds,
    triggerRaw,
    upsellVariantId: String(rule.upsellVariantId || "").trim(),

    // on garde l’ancien pour compat'
    excludeVariantId: excludeRaw,
    // et on ajoute la version liste
    excludeVariantIds: excludeIds,

    replaceVariantId: String(rule.replaceVariantId || "").trim(),

    upsellType: rule.upsellType || "paid",

    // styles carte
    cardBg: rule.cardBg || "",
    cardRadius: Number(rule.cardRadius) || 0,
    cardBorderWidth: Number(rule.cardBorderWidth) || 0,
    cardBorderColor: rule.cardBorderColor || "",

    imageOverride: rule.imageOverride || null,

    // 🔹 Titre & prix custom
    customTitle: rule.customTitle || "",
    customPriceMain: rule.customPriceMain || "",
    customPriceCompare: rule.customPriceCompare || "",

    // 🔹 Couleurs de prix
    priceMainColor: rule.priceMainColor || "",
    priceCompareColor: rule.priceCompareColor || "",

    // Bouton
    buttonLabel: rule.buttonLabel || "",
    buttonBg: rule.buttonBg || "",
    buttonTextColor: rule.buttonTextColor || "",
    buttonRadius: Number(rule.buttonRadius) || 0,
    buttonBorderWidth: Number(rule.buttonBorderWidth) || 0,
    buttonBorderColor: rule.buttonBorderColor || "",
  };
});

let matchingRules = normalizedRules.filter((rule) => {
  // on ne garde que les règles avec un upsell valide
  if (!rule.upsellHandle || !rule.upsellVariantId) return false;

  // ---------- TRIGGER ----------
  let triggerOk = true;

  if (rule.triggerIds.length === 0) {
    // aucun trigger → upsell global
    triggerOk = true;
  } else {
    const needed = {};
    rule.triggerIds.forEach((id) => {
      const key = String(id).trim();
      needed[key] = (needed[key] || 0) + 1;
    });

    triggerOk = Object.entries(needed).every(([id, countNeeded]) => {
      const key = String(id);
      const qtyInCart =
        (quantitiesByVariantId[key] || 0) +
        (quantitiesByProductId[key] || 0);

      if (rule.upsellType === "gift") {
        // 🎁 Pour les cadeaux : au moins countNeeded parents
        return qtyInCart >= countNeeded && qtyInCart > 0;
      } else {
        // 🔵 Logique historique pour les upsells payants / upgrades
        return qtyInCart === countNeeded;
      }
    });
  }

  if (!triggerOk) return false;

  // ---------- EXCLUDE / LIMITE CADEAUX ----------
  let excludeOk = true;

  if (rule.upsellType === "gift") {
    // 🎁 Limite globale par groupe de cadeaux :
    // groupe = tous les gifts avec les mêmes triggers (triggerRaw)
    const sameGroupGiftVariantIds = normalizedRules
      .filter(
        (r) =>
          r.upsellType === "gift" && r.triggerRaw === rule.triggerRaw
      )
      .map((r) => String(r.upsellVariantId || "").trim());

    // quantité totale de TOUS les cadeaux du groupe dans le panier
    let totalGiftQty = 0;
    sameGroupGiftVariantIds.forEach((gid) => {
      totalGiftQty += quantitiesByVariantId[gid] || 0;
    });

    // quantité totale de parents
    let parentQty = 0;
    rule.triggerIds.forEach((id) => {
      const key = String(id);
      parentQty +=
        (quantitiesByVariantId[key] || 0) +
        (quantitiesByProductId[key] || 0);
    });

    // On affiche l'upsell tant que totalGiftQty < parentQty
    excludeOk = totalGiftQty < parentQty;
  } else if (rule.excludeVariantIds && rule.excludeVariantIds.length) {
    // 🔵 Multi-exclude pour les upsells payants :
    // si AU MOINS UN des IDs est présent dans le panier → on exclut
    const anyPresent = rule.excludeVariantIds.some((rawId) => {
      const id = String(rawId);
      return (
        variantIdsInCart.includes(id) ||
        productIdsInCart.includes(id)
      );
    });

    excludeOk = !anyPresent;
  }

  return excludeOk;
});


        // ❌ pas de doublon sur la même variante d’upsell
        const used = new Set();
        matchingRules = matchingRules.filter((rule) => {
          if (used.has(rule.upsellVariantId)) return false;
          used.add(rule.upsellVariantId);
          return true;
        });

        // Rien à afficher
        if (!matchingRules.length) {
          container.innerHTML = "";
          container.hidden = true;
          return;
        }

        // 👉 3 groupes : CADEAUX / UPGRADES / PAYANTS CLASSIQUES
        const giftRules = matchingRules.filter(
          (rule) => rule.upsellType === "gift"
        );

        const paidRules = matchingRules.filter(
          (rule) => rule.upsellType !== "gift"
        );

        // 🔼 Upgrades = payants AVEC replaceVariantId (remplacent des produits existants)
        const upgradeRules = paidRules.filter(
          (rule) =>
            rule.replaceVariantId &&
            String(rule.replaceVariantId).trim() !== ""
        );

        // 🟦 Payants classiques = payants SANS replaceVariantId
        // → ce sont les SEULS qui doivent aller dans "80% des clients achètent aussi"
        let classicPaidRules = paidRules.filter(
          (rule) =>
            !rule.replaceVariantId ||
            String(rule.replaceVariantId).trim() === ""
        );

        // 🔒 Sécurité anti-doublons :
        // si un produit est utilisé dans une règle d’UPGRADE, on NE l’affiche PAS
        // dans les upsells payants classiques ("80% des clients achètent aussi").
        const upgradeHandles = new Set(
          upgradeRules.map((r) => r.upsellHandle)
        );
        const upgradeVariantIds = new Set(
          upgradeRules.map((r) => r.upsellVariantId)
        );

        classicPaidRules = classicPaidRules.filter(
          (rule) =>
            !upgradeHandles.has(rule.upsellHandle) &&
            !upgradeVariantIds.has(rule.upsellVariantId)
        );

        // 🔹 REMPLIR LES SLOTS D’UPGRADE PAR LIGNE DE PRODUIT
        const slots = Array.from(
          document.querySelectorAll(UPSell.slotSelector)
        );

        if (slots.length && upgradeRules.length) {
          const upgradeParts = await Promise.all(
            upgradeRules.map((rule) =>
              fetch(
                `/products/${rule.upsellHandle}?view=upsell-card&variant=${rule.upsellVariantId}`
              ).then((r) => r.text())
            )
          );

          // si un refresh plus récent a démarré pendant les fetch, on annule
          if (runId !== latestRefreshRunId) return;

          upgradeRules.forEach((rule, index) => {
            const html = upgradeParts[index];
            if (!html) return;

            const fromIds = String(rule.replaceVariantId || "")
              .split(",")
              .map((s) => s.trim())
              .filter(Boolean);

            if (!fromIds.length) return;

            // Tous les slots qui concernent cette upgrade
            const matchingSlots = slots.filter((slot) => {
              const parentVariantId = slot.dataset.upsellParentVariant;
              return parentVariantId && fromIds.includes(parentVariantId);
            });

            if (!matchingSlots.length) return;

            // 👉 Si l’upgrade remplace plusieurs variantes (pack découverte),
            // on affiche la carte SOUS LE DERNIER produit concerné.
            const targetSlot =
              fromIds.length > 1
                ? matchingSlots[matchingSlots.length - 1] // dernier dans le DOM
                : matchingSlots[0];

            const placeholder = targetSlot.querySelector(
              ".cart-item-upsell-placeholder"
            );

            if (placeholder && !placeholder.dataset.upsellFilled) {
              // On wrappe la carte dans un layout horizontal "inline"
              const wrapper = document.createElement("div");
              wrapper.innerHTML = html.trim();
              const cardEl = wrapper.querySelector("[data-upsell-card]");

              // 👉 appliquer les styles du Theme Editor
              styleUpsellCard(cardEl, rule);

              // Réinjecter la version stylée dans le panier
              placeholder.innerHTML = `
                <div class="cart-item-upsell-inline">
                  <div class="svg-arrow-upgrade">
                    <svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 360.23 101.26"><g id="kWaKtJ"><path d="M339.57,27.79c-17.71,17.8-38.1,30.77-60.75,40.14A208.78,208.78,0,0,1,41.53,12.59c-.77-.87-1.53-1.76-2.32-2.62-5.16-5.67-11.66-6.46-16.7-2S17,19,22.13,24.34C32.17,34.76,42,45.62,53.18,54.67c47,37.94,101.1,55,161.26,51.14,52-3.36,97.77-22.88,137.18-57.1,1.11-1,2.23-1.92,4.09-3.52.15,2.23.34,3.75.35,5.27,0,10.67-.12,21.34.07,32,.14,8.36,6.16,13.85,13.28,12.55a11.1,11.1,0,0,0,9.28-10.88q.18-34,0-68c0-6.55-4.93-11-11.75-11q-33-.11-66,0c-7,0-11.85,4.34-12.21,10.59s4.36,11.64,11.45,11.94c8.48.35,17,.11,25.49.13Z" transform="translate(-18.55 -5.09)"/></g></svg>
                  </div>
                  ${wrapper.innerHTML}
                </div>
              `;

              targetSlot.hidden = false;
              placeholder.dataset.upsellFilled = "true";
            }
          });
        }

        // On garde l’ordre réel des cartes dans le container
        // (cadeaux + payants classiques, SANS upgrades)
        const renderedRules = [...giftRules, ...classicPaidRules];

        let html = "";

        // 🎁 FREE GIFTS
        if (giftRules.length) {
          const giftParts = await Promise.all(
            giftRules.map((rule) =>
              fetch(
                `/products/${rule.upsellHandle}?view=upsell-card&variant=${rule.upsellVariantId}`
              ).then((r) => r.text())
            )
          );

          if (runId !== latestRefreshRunId) return;

          html += `
            <div class="cart-drawer-upsell-wrapper cart-drawer-upsell-wrapper--gifts">
              <p class="cart-drawer-upsell-heading">
                🎁 Choisissez votre cadeau
              </p>
              <div class="cart-drawer-upsell-track">
                ${giftParts.join("")}
              </div>
            </div>
          `;
        }

        // 🟦 UPSELLS PAYANTS "CLASSIQUES" (hors upgrades)
        let paidProductJsons = [];
        if (classicPaidRules.length) {
          const paidParts = await Promise.all(
            classicPaidRules.map((rule) =>
              Promise.all([
                fetch(`/products/${rule.upsellHandle}?view=upsell-card&variant=${rule.upsellVariantId}`)
                  .then((r) => r.text()).catch(() => null),
                fetch(`/products/${rule.upsellHandle}.js`)
                  .then((r) => r.json()).catch(() => null),
              ])
            )
          );

          paidProductJsons = paidParts.map((p) => p[1] || null);

          if (runId !== latestRefreshRunId) return;

          html += `
            <div class="cart-drawer-upsell-wrapper cart-drawer-upsell-wrapper--paid">
              <p class="cart-drawer-upsell-heading">
                80% des clients achètent aussi
              </p>
              <div class="cart-drawer-upsell-track">
                ${paidParts.map((p) => p[0] || "").join("")}
              </div>
            </div>
          `;
        }

        // Rien à afficher (aucun gift ni paid classique après filtrage)
        if (!html) {
          container.innerHTML = "";
          container.hidden = true;
          return;
        }

        // On injecte TOUT le HTML (cadeaux + upsells payants classiques)
        container.innerHTML = html;
        container.hidden = false;

        // 🎨 Appliquer les styles / textes par upsell
        applyUpsellStyles(container, renderedRules);

        // 💰 Mettre à jour le prix du bouton S'abonner avec le vrai prix sub
        classicPaidRules.forEach((rule, i) => {
          updateSubBtnPrice(container, rule.upsellVariantId, paidProductJsons[i]);
        });
      } catch (e) {
        console.error("[UPSELL] error", e);
      }
    },
  };

  // === STYLES PAR CARTE (appelé pour les cartes classiques + upgrades inline) ===
  function styleUpsellCard(card, rule) {
    if (!card || !rule) return;

    // --- Carte ---
    const cardStyle = card.style;
    if (rule.cardBg) cardStyle.backgroundColor = rule.cardBg;
    if (!isNaN(rule.cardRadius) && rule.cardRadius > 0) {
      cardStyle.borderRadius = rule.cardRadius + "px";
    }
    if (!isNaN(rule.cardBorderWidth)) {
      cardStyle.borderWidth = rule.cardBorderWidth + "px";
      cardStyle.borderStyle =
        rule.cardBorderWidth > 0 ? "solid" : "none";
    }
    if (rule.cardBorderColor) {
      cardStyle.borderColor = rule.cardBorderColor;
    }

    // --- Image override ---
    if (rule.imageOverride) {
      const imgWrapper = card.querySelector("[data-upsell-image-wrapper]");
      if (imgWrapper) {
        const img = imgWrapper.querySelector("img");
        if (img) img.src = rule.imageOverride;
      }
    }

    // --- Titre ---
    const titleEl = card.querySelector("[data-upsell-title]");
    if (titleEl) {
      if (rule.customTitle) titleEl.textContent = rule.customTitle;
    }

    // --- PRIX PRINCIPAL : texte custom + couleur ---
    const mainWrapper = card.querySelector("[data-upsell-price-main]");
    if (mainWrapper) {
      // 1) texte custom avec {price}
      if (rule.customPriceMain) {
        const priceNode =
          mainWrapper.querySelector(".trans-money") || mainWrapper;
        const rawPrice = priceNode.textContent.trim();
        const tpl = rule.customPriceMain;
        const final = tpl.includes("{price}")
          ? tpl.replace("{price}", rawPrice)
          : tpl;

        // on remplace tout le contenu par ton texte custom
        mainWrapper.textContent = final;
      }

      // 2) couleur
      if (rule.priceMainColor) {
        const mainNode =
          mainWrapper.querySelector(".trans-money") || mainWrapper;
        mainNode.style.setProperty("color", rule.priceMainColor, "important");
      }
    }

    // --- PRIX BARRÉ : texte custom + couleur ---
    const compareWrapper = card.querySelector("[data-upsell-price-compare]");
    if (compareWrapper) {
      // 1) texte custom avec {compare_price}
      if (rule.customPriceCompare) {
        const compareNode =
          compareWrapper.querySelector(".trans-money") || compareWrapper;
        const rawCompare = compareNode.textContent.trim();
        const tplC = rule.customPriceCompare;
        const finalC = tplC.includes("{compare_price}")
          ? tplC.replace("{compare_price}", rawCompare)
          : tplC;

        compareWrapper.textContent = finalC;
      }

      // 2) couleur
      if (rule.priceCompareColor) {
        const compareNode =
          compareWrapper.querySelector(".trans-money") || compareWrapper;
        compareNode.style.setProperty(
          "color",
          rule.priceCompareColor,
          "important"
        );
      }
    }

    // --- Bouton ---
    const btn = card.querySelector("[data-upsell-button]");
    if (btn) {
      if (rule.buttonLabel) btn.textContent = rule.buttonLabel;
      if (rule.buttonBg) btn.style.backgroundColor = rule.buttonBg;
      if (rule.buttonTextColor) btn.style.color = rule.buttonTextColor;
      if (!isNaN(rule.buttonRadius))
        btn.style.borderRadius = rule.buttonRadius + "px";
      if (!isNaN(rule.buttonBorderWidth)) {
        btn.style.borderWidth = rule.buttonBorderWidth + "px";
        btn.style.borderStyle =
          rule.buttonBorderWidth > 0 ? "solid" : "none";
      }
      if (rule.buttonBorderColor) btn.style.borderColor = rule.buttonBorderColor;
    }
  }

  function renderUpsellCard(rule, product, variant, cardElement) {
    const imgEl = cardElement.querySelector('.cart-drawer-upsell-image');
    if (!imgEl) return;

    if (rule.imageOverride) {
      imgEl.src = rule.imageOverride;
      imgEl.removeAttribute('srcset');
      return;
    }

    if (variant && variant.featured_image) {
      imgEl.src = variant.featured_image.src;
    } else if (product && product.featured_image) {
      imgEl.src = product.featured_image.src;
    }
  }

  function applyUpsellStyles(container, rules) {
    const cards = container.querySelectorAll("[data-upsell-card]");
    cards.forEach((card, index) => {
      const rule = rules[index];
      styleUpsellCard(card, rule);
    });
  }

  function formatMoneyFromCents(cents) {
    const fmt = (window.Shopify && window.Shopify.money_format) || "";
    const amount = (cents / 100).toFixed(2);
    if (fmt) {
      return fmt
        .replace("{{amount}}", amount)
        .replace("{{amount_with_comma_separator}}", amount.replace(".", ","))
        .replace("{{amount_no_decimals}}", Math.round(cents / 100))
        .replace("{{amount_no_decimals_with_comma_separator}}", Math.round(cents / 100));
    }
    return amount.replace(".", ",") + " €";
  }

  function updateSubBtnPrice(container, variantId, productJson) {
    if (!productJson) return;
    const variant = (productJson.variants || []).find(v => String(v.id) === String(variantId));
    if (!variant) return;
    const alloc = (variant.selling_plan_allocations || [])[0];
    if (!alloc || alloc.price == null) return;
    const subBtn = container.querySelector(
      `[data-upsell-subscribe][data-variant-id="${variantId}"]`
    );
    if (!subBtn) return;
    const priceEl = subBtn.querySelector(".upsell-atc-price");
    if (priceEl) priceEl.textContent = formatMoneyFromCents(alloc.price);
  }

  // 🔁 Débounce centralisé des refresh
  function scheduleUpsellRefresh(delay = 0) {
    if (upsellRefreshTimeout) clearTimeout(upsellRefreshTimeout);
    upsellRefreshTimeout = setTimeout(() => {
      upsellRefreshTimeout = null;
      UPSell.refresh();
    }, delay);
  }

  function refreshUpsell() {
    scheduleUpsellRefresh(0);
  }

  // exposé pour debug console
  window.MOODZ_UPSELL_REFRESH = refreshUpsell;
  window.updateUpsell = refreshUpsell;

  // Patch du cart-drawer → à chaque renderContents on relance l’upsell
  function patchCartDrawer() {
    if (!window.customElements || !window.customElements.whenDefined) return;

    window.customElements.whenDefined("cart-drawer").then(() => {
      const Drawer = customElements.get("cart-drawer");
      if (!Drawer || Drawer.prototype.__upsellPatched__) return;

      Drawer.prototype.__upsellPatched__ = true;

      const original = Drawer.prototype.renderContents;
      if (typeof original !== "function") return;

      Drawer.prototype.renderContents = function (state) {
        const result = original.call(this, state);
        scheduleUpsellRefresh(80);
        return result;
      };
    });
  }

  // Fallback : observe le DOM du drawer
  function initUpsellObserver() {
    const target = document.querySelector("#CartDrawer-CartItems");
    if (!target) return;

    const observer = new MutationObserver(() => {
      scheduleUpsellRefresh(80);
    });

    observer.observe(target, {
      childList: true,
      subtree: true,
    });
  }

  // Fallback 2 : observe le badge du nombre d’items
  function startCartCountWatcher() {
    let lastItemCount = null;

    function getCartItemCount() {
      const badge = document.querySelector(".gb-cart-total-item");
      if (!badge) return null;
      const value = parseInt(badge.textContent.trim(), 10);
      return isNaN(value) ? null : value;
    }

    function checkCartAndUpdateUpsell() {
      const currentCount = getCartItemCount();
      if (currentCount === null) return;

      if (lastItemCount === null) {
        lastItemCount = currentCount;
        scheduleUpsellRefresh(0);
        return;
      }

      if (currentCount !== lastItemCount) {
        lastItemCount = currentCount;
        scheduleUpsellRefresh(100);
      }
    }

    setInterval(checkCartAndUpdateUpsell, 300);
  }

  // Gestion du bouton "Ajouter au panier" / "Upgrade" / "Free gift"
  document.addEventListener("click", async function (event) {
    const btn = event.target.closest("[data-upsell-add-to-cart]");
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    const rawRules = Array.isArray(window.MOODZ_UPSELL_RULES)
      ? window.MOODZ_UPSELL_RULES
      : [];

    // On étend les règles pour connaître aussi upsellType + triggerRaw
    const rules = rawRules.map((rule) => ({
      upsellVariantId: String(rule.upsellVariantId || "").trim(),
      replaceVariantId: String(rule.replaceVariantId || "").trim(),
      upsellType: rule.upsellType || "paid",
      triggerRaw: String(rule.triggerVariantId || "").trim(),
    }));

    const rule = rules.find(
      (r) =>
        r.upsellVariantId !== "" &&
        r.upsellVariantId === String(variantId)
    );

    let idsToRemove = [];
    if (rule && rule.replaceVariantId) {
      idsToRemove = rule.replaceVariantId
        .split(",")
        .map((v) => v.trim())
        .filter((v) => v !== "");
    }

    btn.disabled = true;
    btn.classList.add("is-loading");

    try {
      // 1️⃣ Supprimer les variantes à remplacer, si configurées (UPGRADE)
      if (idsToRemove.length > 0) {
        const updates = {};
        idsToRemove.forEach((id) => {
          updates[id] = 0;
        });

        await fetch("/cart/update.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({ updates }),
        });
      }

      // 2️⃣ Ajouter la variante d’upsell (avec properties si FREE GIFT)

const payload = {
  id: Number(variantId),
  quantity: 1,
};

if (rule && rule.upsellType === "gift" && rule.triggerRaw) {
  const firstTriggerId = rule.triggerRaw
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean)[0];

  if (firstTriggerId) {
    payload.properties = {
      _upsell_parent_variant_id: String(firstTriggerId),
      Cadeau: "Cadeau offert", // ⚡ EXACTEMENT comme dans product-form.js
    };
  }
}



      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      // 3️⃣ Recharger le drawer
      const sectionHtml = await fetch("/cart?section_id=cart-drawer").then(
        (r) => r.text()
      );
      const parser = new DOMParser();
      const doc = parser.parseFromString(sectionHtml, "text/html");

      const newCartDrawer = doc.querySelector("cart-drawer");
      const currentCartDrawer = document.querySelector("cart-drawer");

      if (newCartDrawer && currentCartDrawer) {
        currentCartDrawer.innerHTML = newCartDrawer.innerHTML;
      }

      // 4️⃣ Relancer l’upsell engine
      if (typeof window.MOODZ_UPSELL_REFRESH === "function") {
        setTimeout(() => {
          window.MOODZ_UPSELL_REFRESH();
        }, 50);
      }
    } catch (error) {
      console.error("[UPSELL ATC] Erreur lors de l’ajout / upgrade", error);
      alert(
        "Oups, impossible d'ajouter ou de mettre à jour ce produit dans le panier pour le moment."
      );
    } finally {
      btn.disabled = false;
      btn.classList.remove("is-loading");
    }
  });

  /* ── S'ABONNER (Seal Subscriptions / Selling Plan) ── */
  document.addEventListener("click", async function (e) {
    const btn = e.target.closest("[data-upsell-subscribe]");
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    const handle    = btn.dataset.productHandle;
    let sellingPlanId = btn.dataset.sellingPlanId
                          ? Number(btn.dataset.sellingPlanId)
                          : null;

    if (!variantId || !handle) return;

    btn.disabled = true;
    btn.classList.add("is-loading");

    try {
      // Si selling_plan_id absent ou 0 depuis Liquid → fetch /products/handle.js
      if (!sellingPlanId) {
        const data = await fetch(`/products/${handle}.js`).then(r => r.json());
        const firstGroup = (data.selling_plan_groups || [])[0];
        const firstPlan  = firstGroup ? (firstGroup.selling_plans || [])[0] : null;
        sellingPlanId = firstPlan ? firstPlan.id : null;
      }

      if (!sellingPlanId) {
        console.warn("[UPSELL SUBSCRIBE] Pas de selling_plan trouvé pour", handle);
        return;
      }

      await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          id: Number(variantId),
          quantity: 1,
          selling_plan: sellingPlanId,
        }),
      });

      const sectionHtml = await fetch("/cart?section_id=cart-drawer").then(r => r.text());
      const doc = new DOMParser().parseFromString(sectionHtml, "text/html");
      const newDrawer = doc.querySelector("cart-drawer");
      const curDrawer = document.querySelector("cart-drawer");
      if (newDrawer && curDrawer) curDrawer.innerHTML = newDrawer.innerHTML;

      if (typeof window.MOODZ_UPSELL_REFRESH === "function") {
        setTimeout(window.MOODZ_UPSELL_REFRESH, 50);
      }
    } catch (err) {
      console.error("[UPSELL SUBSCRIBE ATC]", err);
    } finally {
      btn.disabled = false;
      btn.classList.remove("is-loading");
    }
  });

  document.addEventListener("DOMContentLoaded", () => {
    patchCartDrawer();
    initUpsellObserver();
    startCartCountWatcher();
    refreshUpsell();
  });
})();
